import { Layout, Menu, Row, Typography } from "antd";
import { menuItems } from "../lib/menuItems";
import { useLocation, useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { useState } from "react";
const { Sider } = Layout;
const { Title } = Typography;
export default function LayoutSidebar() {
  const { permissions, transaction_noti } = useSelector((state) => state.user);
  const navigate = useNavigate();
  const location = useLocation();

  const [collapsed, setCollapsed] = useState(false); 

  const findSelectedKey = () => {
    const currentItem = menuItems.find(
      (item) => item.pathname === location.pathname
    );
    if (currentItem) return currentItem.key;

    for (const item of menuItems) {
      if (item.children) {
        const childItem = item.children.find(
          (child) => child.pathname === location.pathname
        );
        if (childItem) return childItem.key;
      }
    }
    return "1";
  };

  function handleMenuClick({ key }) {
    let selectedMenuItem = menuItems.find((item) => item.key === key);

    if (!selectedMenuItem) {
      menuItems.forEach((item) => {
        if (item.children) {
          const childItem = item.children.find((child) => child.key === key);
          if (childItem) {
            selectedMenuItem = childItem;
          }
        }
      });
    }
    if (selectedMenuItem.pathname) {
      navigate(selectedMenuItem.pathname);
    }
  }

  const filteredMenuItems = menuItems.map((item) => {
    if (item.showBadge && transaction_noti > 0) {
      return {
        ...item,
        label: (
          <Row justify="space-between" align="middle">
            <span>{item.label}</span>
            <div
              style={{
                backgroundColor: "#ff4d4f",
                opacity: "0.8",
                width: "12px",
                height: "12px",
                borderRadius: "50px",
              }}
            />
          </Row>
        ),
      };
    }

    if (item.children) {
      const filteredChildren = item.children.filter(
        (child) =>
          !child.permissions ||
          child.permissions.every((perm) => permissions.includes(perm))
      );
      if (
        filteredChildren.length > 0 ||
        !item.permissions ||
        item.permissions.every((perm) => permissions.includes(perm))
      ) {
        return { ...item, children: filteredChildren };
      }
      return null;
    }

    return !item.permissions ||
      item.permissions.every((perm) => permissions.includes(perm))
      ? item
      : null;
  });

  return (
    <Sider 
    collapsible 
    style={{ height: "100vh" }}
    collapsed={collapsed} 
    onCollapse={(value) => setCollapsed(value)}
    >
      <Title style={{ textAlign: "center" }}>
      {collapsed ? "A" : "Agent"}
      </Title>
      <Menu
        mode="inline"
        items={filteredMenuItems}
        selectedKeys={[findSelectedKey()]}
        onClick={handleMenuClick}
      />
    </Sider>
  );
}
